import axios from 'axios';

const baseURL = import.meta.env.MODE === 'production'
  ? '/api/v1'
  : '/api/v1'; // Let Vite proxy handle this in dev

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add Authorization token automatically if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tkn');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle responses and errors uniformly
api.interceptors.response.use(
  (res) => res.data,
  (err) => {
    throw err?.response?.data || { message: 'Unknown error' };
  },
);

export default api;
